<template>
  <div class="all-menus">
    <div class="all-menus-search">
      <el-input v-model="keyword" style="width: 70%;" :placeholder="$t('common.input')" @input="searchMenus">
        <i slot="suffix" class="el-input__icon el-icon-search" />
      </el-input>
    </div>
    <div class="all-menus-popover">
      <div
        v-for="menu in menus"
        :key="menu.name"
        class="all-menus-menu-list"
      >
        <div class="all-menus-menu-cell is-menu-title">
          <div>
            <i class="iconfont" :class="`icon-${menu.icon}`" />
            &nbsp;
            <span v-html="menu.name" />
          </div>
          <div
            class="fixed-icon-trigger"
            @click.stop="fixedAllMenusInSideBar(menu)"
          >
            <span class="fixed-icon fixed-text">{{ isSelectALl(menu) ? $t('common.allUnFixed') : $t('common.allFixed') }}</span>
            <!-- <i
              class="fixed-icon iconfont icon-suoding"
              :class="{ 'is-fixed': false }"
            /> -->
            <!-- :class="fixedMenus.has(`${item.id}`) ? 'icon-suoding is-fixed' : 'icon-suoding'" -->
          </div>
        </div>

        <div
          v-for="item in menu.children"
          :key="item.id"
          :class="['all-menus-menu-cell', 'is-menu-cell', { 'is-active-menu': item.vueUrl && (item.vueUrl === $route.name || item.vueUrl === $route.meta.dep) }]"
          @click="chooseMenu(item)"
        >
          <div>
            <i class="iconfont" :class="`icon-${item.icon}`" />
            <span v-html="item.name" />
          </div>
          <div
            class="fixed-icon-trigger"
            @click.stop="fixedMenuInSideBar(item)"
          >
            <i
              class="fixed-icon iconfont icon-suoding"
              :class="{ 'is-fixed': fixedMenus.has(`${item.id}`) }"
            />
            <!-- :class="fixedMenus.has(`${item.id}`) ? 'icon-suoding is-fixed' : 'icon-suoding'" -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'throttle-debounce/debounce'

export default {
  data() {
    return {
      keyword: '',
      menus: []
    }
  },
  computed: {
    allMenus() {
      return this.$store.getters.menus.children || []
    },
    fixedMenus() {
      return new Set(this.$store.getters.fixedMenus)
    }
  },
  created() {
    this.menus = [...this.allMenus]
  },
  methods: {
    searchMenus: debounce(300, function() {
      this.menus = this.getMapMenus(this.allMenus)
    }),
    getMapMenus(allMenus) {
      if (!this.keyword) return allMenus
      const menus = []
      allMenus.forEach(item => {
        if (!item || !item.name || item.dep) return
        const { children } = item
        if (item.name && item.name.includes(this.keyword)) {
          return menus.push({
            ...item,
            name: item.name.replace(this.keyword, i => `<em>${i}</em>`)
          })
        }
        if (!children || !children.length) return
        const childrenMenus = this.getMapMenus(children)
        if (!childrenMenus || !childrenMenus.length) return
        menus.push({
          ...item,
          name: item.name.replace(this.keyword, i => `<em>${i}</em>`),
          children: childrenMenus
        })
      })
      return menus
    },
    chooseMenu(menu) {
      this.$emit('choose-menu', menu)
    },
    fixedMenuInSideBar(menu) {
      if (this.fixedMenus.has(`${menu.id}`)) {
        this.$store.dispatch('menu/unFixedMenu', menu)
        this.$emit('un-fixed-menu')
      } else {
        this.$store.dispatch('menu/fixedMenu', menu)
        this.$emit('fixed-menu')
      }
    },
    isSelectALl(menu) {
      const children = menu.children || []
      if (!children.length) return false
      for (let i = 0; i < children.length; i++) {
        const item = children[i]
        if (!this.fixedMenus.has(`${item.id}`)) return false
      }
      return true
    },
    fixedAllMenusInSideBar(menu) {
      if (this.isSelectALl(menu)) {
        this.$store.dispatch('menu/unFixedMenus', menu)
        this.$emit('un-fixed-menu')
      } else {
        this.$store.dispatch('menu/fixedMenus', menu.children || [])
        this.$emit('fixed-menu')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.all-menus {
  padding: 10px 0;
  width: 60vw;
  &-search {
    padding: 0 20px;
  }
  &-popover {
    // column-count: 4;
    column-gap: 0;
    column-width: 15vw;
  }
  &-menu-list {
    display: inline-block;
    width: 100%;
    break-inside: auto;
  }
  &-menu-cell {
    font-size: 12px;
    white-space: nowrap;
    &.is-menu-title {
      font-size: 14px;
      font-weight: bold;
      margin-top: 10px;
      color: #333;
    }
    &.is-menu-cell:hover {
      background: #f3f3f3;
    }
    &.is-active-menu {
      color: #038EE3;
    }
    .fixed-icon {
      font-size: 14px;
      display: none;
      color: #606266;
      &-trigger {
        padding: 0 5px;
        &:hover .fixed-icon {
          color: #FF9E00;
        }
      }
    }
    &:hover .fixed-icon {
      display: inline-block;
      color: #FF9E00;
      &.fixed-text {
        color: #999;
        &:hover {
          color: #333;
        }
      }
    }
    .fixed-icon.is-fixed {
      display: inline-block;
      // transform: scale(1.2);
      color: #FF9E00!important;
    }
    .fixed-text {
      font-size: 12px;
      font-weight: normal;
    }
    cursor: pointer;
    padding: 0 20px;
    line-height: 42px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  /deep/ {
    em {
      color: red;
      font-style: normal;
    }
  }
}
</style>
